import { render } from "./FormDoctor.vue?vue&type=template&id=681151ef"
import script from "./FormDoctor.vue?vue&type=script&lang=js"
export * from "./FormDoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__